import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"
import { dsColorNew } from "@palette"


export default function ReportHomeListTableStoppedBlock({ date }) {

	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
		<Typography variant="caption">
			{formatDate(date, {
				isString: true,
				format: 'dd MMM yyyy HH:mm',
				receivedFormat: dateFormatReceiver(date)
			})}
		</Typography>
		<Typography variant="body1">
			<IconSeeker icon="hand" sx={{ color: dsColorNew.dangerRed }}/> Stopped
		</Typography>
	</Box>
}